import Icon from '@mdi/react';
import React, { ChangeEvent, FormEvent, MouseEvent, useCallback } from 'react';
import { AppCustomIcons } from '../../utils/custom-icons';
import { AppSvgIcon } from '../svg-icon/app-svg-icon';
import './app-input-text.scss';

export type InputTextDirectionType = 'horizontal' | 'vertical';

export interface AppInputTextProps {
  type?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  maxLength?: number;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  icon?: string;
  svgIcon?: AppCustomIcons;
  errorMessage?: string;
  required?: boolean;
  value?: string;
  arrangement?: InputTextDirectionType;
  trimSpaces?: boolean;
  onChange?: (value: string | undefined, e: ChangeEvent<HTMLInputElement>) => void;
  onIconClick?: (a: MouseEvent<HTMLButtonElement | SVGSVGElement> | React.KeyboardEvent<SVGSVGElement>) => void;
  onPaste?: (e: FormEvent) => void;
  onCopy?: (e: FormEvent) => void;
  valid?: boolean;
}

export const AppInputText = (props: AppInputTextProps) => {
  const {
    type = 'text',
    inputMode,
    maxLength,
    label,
    placeholder,
    disabled,
    errorMessage = '',
    icon,
    required,
    value,
    valid = true,
    svgIcon,
    arrangement = 'vertical',
    trimSpaces = true,
    onChange,
    onIconClick,
    onCopy,
    onPaste
  } = props;

  const onTextChanged = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        let newValue = e.target.value || undefined;

        if (trimSpaces && newValue) {
          newValue = newValue.trim() || undefined;
        }

        onChange(newValue, e);
      }
    },
    [onChange, trimSpaces]
  );

  return (
    <div className={`input-text ${arrangement === 'horizontal' ? ' horizontal' : ''}`}>
      {label && (
        <label>
          {label}
          {required ? '*' : ''}
        </label>
      )}
      <div className='input-wrapper'>
        <input
          className={!valid ? 'input-error' : errorMessage && 'input-error'}
          type={type}
          inputMode={inputMode}
          maxLength={maxLength}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={onTextChanged}
          onPaste={onPaste}
          onCopy={onCopy}
        />
        {icon && (
          <button type='button' className='icon' onClick={onIconClick}>
            <Icon path={icon} size={1} color='#C4C4C4' />
          </button>
        )}
        {svgIcon && <AppSvgIcon icon={svgIcon} onClick={onIconClick} />}
      </div>
      {errorMessage && (
        <div className='message'>
          <span className='error-message'>{errorMessage}</span>
        </div>
      )}
    </div>
  );
};
